
import { throwError as observableThrowError, Observable } from 'rxjs';

import { catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';


import { ServiceBase } from '@app/services/base.service';

import { MeAvise } from '@app/models/me-avise';
import { EncaminharPrazo, PrazoGerenciamentoPesquisa } from '@app/pages/processos/gerenciar-prazos/gerenciar-prazos.model';

@Injectable()
export class PrazoService extends ServiceBase {
  constructor(private http: HttpClient) {
    super();
  }

  adicionar(meAvise: MeAvise): Observable<any> {
    return this.http
      .post<any>(this.URL_API + 'processos/gerenciarPrazosJudicial', meAvise);
  }

  alterar(meAvise: MeAvise): Observable<any> {
    return this.http
      .put<any>(this.URL_API + 'processos/gerenciarPrazosJudicial', meAvise);
  }

  deletar(id: number): Observable<any> {
    return this.http
      .delete<any>(this.URL_API + `processos/gerenciarPrazosJudicial/${id}`);
  }

  obterPorId(id: number): Observable<any> {
    return this.http
      .get<any>(this.URL_API + `processos/gerenciarPrazosJudicial/${id}`);
  }


  ObterUltimoPrazoNaoConcluido(id: number): Observable<any> {
    return this.http
      .get<any>(this.URL_API + `processos/gerenciarPrazosJudicial/ObterUltimoPrazoNaoConcluido/?processoId=${id}`);
  }


  cronometro(id: number, somenteObter): Observable<any> {
    return this.http
      .get<any>(this.URL_API + `processos/gerenciarPrazosJudicial/cronometro/?prazoId=${id}&somenteObter=${somenteObter}`);
  }

  verificaCronometro() {
    return this.http
      .get<any>(this.URL_API + `processos/gerenciarPrazosJudicial/verificaCronometro`);
  }


  calculaPrazo(dataVinda: string, dias: number): Observable<any> {
    return this.http
      .get<any>(this.URL_API + `processos/gerenciarPrazosJudicial/CalculaPrazo/?dataVinda=${dataVinda}&dias=${dias}`);
  }

  realizar(id: number): Observable<any> {
    return this.http
      .get<any>(this.URL_API + `processos/gerenciarPrazosJudicial/RealizarPrazo/?prazoId=${id}`);
  }

  concluirPrazo(id: number): Observable<any> {
    return this.http
      .get<any>(this.URL_API + `processos/gerenciarPrazosJudicial/ConcluirPrazo/?prazoId=${id}`);
  }

  concluirPrazos(prazos: number[]): Observable<any> {
    return this.http
      .post<any>(this.URL_API + `processos/gerenciarPrazosJudicial/ConcluirPrazos`, prazos);
  }

  desconcluirPrazo(id: number): Observable<any> {
    return this.http
      .get<any>(this.URL_API + `processos/gerenciarPrazosJudicial/DesconcluirPrazo/?prazoId=${id}`);
  }

  encaminharProtocolagem(id: number, usuarioId: number): Observable<any> {
    return this.http
      .get<any>(this.URL_API + `processos/gerenciarPrazosJudicial/EncaminharProtocolagem/?prazoId=${id}&usuarioId=${usuarioId}`);
  }

  protocolar(id: number): Observable<any> {
    return this.http
      .get<any>(this.URL_API + `processos/gerenciarPrazosJudicial/ProtocolarPrazo/?prazoId=${id}`);
  }

  // confirmarProtocolarPrazo(id: number) {
  //   return this.http.get(this.URL_API + `Prazo/ConfirmarProtocolarPrazo/?prazoId=${id}`)
  // }

  // desconfirmarProtocolarPrazo(id: number) {
  //   return this.http.get(this.URL_API + `Prazo/DesconfirmarProtocolarPrazo/?prazoId=${id}`)
  // }


  obterPrazoGerenciamento(filtro: PrazoGerenciamentoPesquisa): Observable<any> {
    return this.http
      .post<any>(this.URL_API + `processos/gerenciarPrazosJudicial/PrazoGerenciamento`, filtro, { headers: { meta: ['search'] } });
  }

  encaminharPrazo(encaminharPrazo: EncaminharPrazo): Observable<any> {
    return this.http
      .post<any>(this.URL_API + `processos/gerenciarPrazosJudicial/Encaminhar`, encaminharPrazo);
  }

  reencaminharPrazo(encaminharPrazo: EncaminharPrazo): Observable<any> {
    return this.http
      .post<any>(this.URL_API + `processos/gerenciarPrazosJudicial/Reencaminhar`, encaminharPrazo);
  }


  obterPrazoGerenciamentoAdm(filtro: PrazoGerenciamentoPesquisa): Observable<any> {
    return this.http
      .post<any>(this.URL_API + `processos/gerenciarprazosadm/obterPrazos`, filtro, { headers: { meta: ['search'] } });
  }

  obterMeAvise(meaviseId: any): Observable<any> {
    return this.http
      .get<any>(this.URL_API + `processos/gerenciarPrazosJudicial/ObterMeAvisePorIdComUsuarioCriacao/?meaviseId=${meaviseId}`).pipe(
        catchError((error: any) => observableThrowError(error)));
  }

  realizarMeAvise(id: number): Observable<any> {
    return this.http
      .get<any>(this.URL_API + `processos/gerenciarPrazosJudicial/RealizarMeAvise/?meaviseId=${id}`).pipe(
        catchError((error: any) => observableThrowError(error)));
  }

  transferirMeAvise(usuarioDestinoId: number, meAviseTransferencia: MeAvise): Observable<any> {
    const dados = {
      id: meAviseTransferencia.Id,
      UsuarioDestinoId: usuarioDestinoId,
      Data: meAviseTransferencia.Data,
      Prazo: meAviseTransferencia.Prazo,
      PrazoInterno: meAviseTransferencia.PrazoInterno
    };
    return this.http
      .post<any>(this.URL_API + `processos/gerenciarPrazosJudicial/TransferirMeAvise`, dados).pipe(
        catchError((error: any) => observableThrowError(error)));
  }
}
